import React from 'react';
import styles from './PricingTable.module.css';
import type { ForemanPricing } from '../../types/foreman';

interface PricingTableProps {
  pricing: ForemanPricing;
}

const PricingTable: React.FC<PricingTableProps> = ({ pricing }) => {
  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Category</th>
            <th>Amount</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {pricing.lines.map((line, idx) => (
            <tr key={idx}>
              <td>{line.cat}</td>
              <td className={styles.amountCol}>{line.amt}</td>
              <td className={styles.noteCol}>{line.note}</td>
            </tr>
          ))}
          {pricing.total && (
            <tr className={styles.totalRow}>
              <td className={styles.totalLabel}>Total</td>
              <td className={styles.amountCol}>{pricing.total}</td>
              <td />
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PricingTable;
